export default __webpack_public_path__ + "static/media/linkedIcon.694e7d4e.PNG";